export function formatAsEuro(value: number) {
    return `€${Number(value).toFixed(2)}`;
}